import * as S from './styles';
const OrganizationPill = ({
  internal_code,
  name
}) => {
  return <S.PillContainer baseColor={Buffer.from(name).toString('hex').slice(-7, -1)}>
      {internal_code}
    </S.PillContainer>;
};
export default OrganizationPill;